import React, { useState, useEffect } from 'react'
import "./quizMain.css";
import { Table } from "antd";
import dayjs from 'dayjs';
import { useColumns } from "../columns.js";
import apiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { DatePicker } from "antd";
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);




const QuizMain = () => {

    const columnsArray = useColumns();

    const [data, setData] = useState([])

    const [filteredData, setFilteredData] = useState([])

    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem('currentPage');
        return savedPage ? JSON.parse(savedPage) : 1;
    });

    const [filterWinners, setFilterWinners] = useState(() => {
        const savedTeam = localStorage.getItem('filterWinners');
        return savedTeam ? JSON.parse(savedTeam) : 2; // Default to 2
    });

    const handleTeam = (value) => {
        setFilterWinners(value);
        localStorage.setItem('filterWinners', JSON.stringify(value)); // Save team selection to localStorage
    };



    // Handle page change and update localStorage
    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem('currentPage', JSON.stringify(page)); // Save current page to localStorage
    };

    const [fields, setFields] = useState(() => {
        const savedFields = localStorage.getItem('fields');
        return savedFields ? JSON.parse(savedFields) : {
            startDate: dayjs().format('YYYY-MM-DD'),
            endDate: dayjs().format('YYYY-MM-DD'),
            mail: "",
        };
    });

    // Function to update fields and sync with localStorage
    const updateFields = (field, value) => {
        setFields((prevFields) => {
            const updatedFields = {
                ...prevFields,
                [field]: value,
            };

            // Save updated fields to localStorage
            localStorage.setItem('fields', JSON.stringify(updatedFields));

            return updatedFields;
        });
    }


    const fetchRowClassName = (record) => {
        // Check the team attribute and return the respective class
        if (record.isWinner) {
            return 'winner-row'; // Apply  background color for winner
        }
    }


    const onDateChange = (field, date) => {
        if (date) {
            const formattedDate = dayjs(date).format('YYYY-MM-DD'); // Format as HH:mm:ss
            updateFields(field, formattedDate); // Save the formatted value
        } else {
            updateFields(field, null); // Handle case where time is cleared
        }
    };

    const filterData = (array) => {
        const dateFiltered = array.filter(item => {
            const date = dayjs(item.createdAt).format('YYYY-MM-DD');
            return date >= fields.startDate && date <= fields.endDate;
        });

        if (fields.mail?.length > 0) {
            const mailFiltered = dateFiltered.filter(item =>
                item.email && item.email.toLowerCase().includes(fields.mail.toLowerCase())
            );

            if (filterWinners === 2) {
                return mailFiltered;
            } else {
                return mailFiltered.filter(item => item.isWinner === true);
            }
        } else {
            if (filterWinners === 2) {
                return dateFiltered;
            } else {
                return dateFiltered.filter(item => item.isWinner === true);
            }
        }
    };

    const getItems = async () => {
        const [success, error] = await apiService.get("quiz/participants");

        if (error) {
            toast.error("Doslo je do greske, pokusajte malo kasnije");
            return;
        }

        setData(success?.data?.participants)
        setFilteredData(success?.data?.participants)
    };

    useEffect(() => {
        getItems();

    }, []);







    return (
        <div className='quizMain'>
            <div className='title'>Pregled svih prijava</div>

            <div className='filters'>
                <div className='holder'>
                    <label htmlFor='dateStart'>Datum od:</label>
                    <DatePicker value={fields.startDate ? dayjs(fields.startDate, 'YYYY-MM-DD') : null}
                        onChange={(date) => onDateChange("startDate", date)}
                        placeholder="YYYY-MM-DD"
                        className="timePicker"
                        allowClear={false}
                        id="dateStart" />
                </div>


                <div className='holder'>
                    <label htmlFor='dateEnd'>Datum do:</label>
                    <DatePicker value={fields.endDate ? dayjs(fields.endDate, 'YYYY-MM-DD') : null}
                        onChange={(date) => onDateChange("endDate", date)}
                        placeholder="YYYY-MM-DD"
                        className="timePicker"
                        allowClear={false}
                        id="dateEnd" />
                </div>

                <div className='holder'>
                    <label htmlFor='mailText'>Email</label>
                    <input type="text" value={fields.mail} onChange={(e) => updateFields("mail", e.target.value)} id="mailText" />
                </div>


                <div className='holder'>
                    <label> Filter</label>

                    <div className='teams'>
                        <div isSelected={filterWinners === 1 ? "true" : ""}
                            onClick={() => handleTeam(1)}>POBEDNICI</div>
                        <div isSelected={filterWinners === 2 ? "true" : ""}
                            onClick={() => handleTeam(2)}>SVE PRIJAVE</div>
                    </div>

                </div>


            </div>


            <Table dataSource={filterData(data)}
                columns={columnsArray}
                bordered={true}
                rowClassName={fetchRowClassName}
                pagination={{
                    current: currentPage,
                    showSizeChanger: true,  // Allow users to change the number of items per page
                    pageSizeOptions: ['5', '10', '20'],
                    onChange: handlePageChange
                }}
            />


        </div>
    )
}

export default QuizMain